import { render, staticRenderFns } from "./EarthIcon.vue?vue&type=template&id=8702021e&scoped=true&"
import script from "./EarthIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./EarthIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8702021e",
  null
  
)

export default component.exports